import { useState } from "react";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What types of equipment do you offer?",
      answer:
        "We offer a wide range of equipment for the sale and Display of Refrigerated, Frozen, Hot & Room temperature food items.",
    },
    {
      question: "Do you provide installation services for bakery equipment?",
      answer:
        "Yes, we offer professional installation services to ensure your equipment is set up correctly and operates efficiently.",
    },
    {
      question: "How can I choose the right bakery equipment for my business?",
      answer:
        "Our team of experts can help you select the best equipment based on your production needs, available space, and budget.",
    },
    {
      question: "What is your warranty policy on bakery equipment?",
      answer:
        "Most of our equipment comes with a 1-year warranty covering manufacturing defects and performance issues.",
    },
  ];

  return (
    <div className="flex flex-col justify-center items-center px-3 lg:m-32">
      <h2 className="text-3xl md:text-5xl font-bold text-[#0b0b0b] mb-12">
        FAQs
      </h2>
      <div className="space-y-8 w-full max-w-4xl">
        {faqs.map((faq, index) => (
          <div key={index} className="border-b border-gray-300 pb-6">
            <h3
              className="text-md md:text-xl xl:text-2xl font-semibold text-[#2C3E50] flex justify-between items-center cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              {faq.question}
              <span className="text-2xl text-[#2C3E50]">
                {openIndex === index ? "−" : "+"}
              </span>
            </h3>
            {openIndex === index && (
              <p className="text-gray-600 mt-2 xl:text-xl">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;

// import { useState } from "react";

// const FAQSection = () => {
//   const [openIndex, setOpenIndex] = useState(null);

//   const toggleFAQ = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   const faqs = [
//     {
//       question: "What types of bakery equipment do you offer?",
//       answer:
//         "We offer a wide range of equipment for the sale and Display of Refrigerated, Frozen, Hot & Room temperature food items.",
//     },
//     {
//       question: "Do you provide installation services for bakery equipment?",
//       answer:
//         "Yes, we offer professional installation services to ensure your equipment is set up correctly and operates efficiently.",
//     },
//     {
//       question: "How can I choose the right bakery equipment for my business?",
//       answer:
//         "Our team of experts can help you select the best equipment based on your production needs, available space, and budget.",
//     },
//     {
//       question: "What is your warranty policy on bakery equipment?",
//       answer:
//         "Most of our equipment comes with a 1-year warranty covering manufacturing defects and performance issues.",
//     },
    
//   ];

//   return (
//     <div className="flex flex-col  text-center justify-center  items-center px-3 lg:m-32">
//       <h2 className="text-3xl md:text-5xl font-bold text-[#0b0b0b] mb-12 text-center">
//         FAQs
//       </h2>
//       <div className="space-y-8">
//         {faqs.map((faq, index) => (
//           <div key={index} className="border-b border-gray-300 pb-6">
//             <h3
//               className="text-md md:text-xl xl:text-2xl 2xl:text-3xl font-semibold text-[#2C3E50] flex justify-between items-center cursor-pointer"
//               onClick={() => toggleFAQ(index)}
//             >
//               {faq.question}
//               <span className="text-2xl text-[#2C3E50] xl:text-2xl">
//                 {openIndex === index ? "−" : "+"}
//               </span>
//             </h3>
//             {openIndex === index && (
//               <p className="text-gray-600 mt-2 xl:text-xl">{faq.answer}</p>
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default FAQSection;
